import React from 'react'

const Component = () => <>Módulo no encontrado</>

export default Component
